export default "__VITE_ASSET__CpMeKpYw__"